import { Component } from '@angular/core';

@Component({
    selector: 'app-registration-orchestrator',
    template: ''
})
export class RegistrationOrchestratorComponent {
  constructor() {}
}
